import { cssGenerator, view } from '@yola/ws-sdk';
import { ALL_DEVICES_BREAKPOINT, DEVICE_BREAKPOINTS } from '../constants/visibility';

const { HIDDEN } = cssGenerator.constants.classNames;

const HIDDEN_BREAKPOINTS = [ALL_DEVICES_BREAKPOINT, ...DEVICE_BREAKPOINTS];

const isHiddenClassToken = (token) =>
  Boolean(token) &&
  HIDDEN_BREAKPOINTS.some((breakpoint) =>
    view.helpers.matchesResponsiveToken(token, HIDDEN, breakpoint)
  );

export const unhideAt = (currentClass, breakpoint) =>
  view.helpers.removeResponsiveClasses({
    currentClass,
    className: HIDDEN,
    breakpoint,
  });

export const hideAt = (currentClass, breakpoint) =>
  view.helpers.getPatchedResponsiveClass({
    currentClass,
    className: HIDDEN,
    value: null,
    breakpoint,
  });

export const hideOnAllDevices = (currentClass) => {
  const strippedClass = DEVICE_BREAKPOINTS.reduce(
    (classValue, breakpoint) => unhideAt(classValue, breakpoint),
    currentClass
  );

  return hideAt(strippedClass, ALL_DEVICES_BREAKPOINT);
};

export const unhideOnlyAt = (currentClass, breakpoint) =>
  DEVICE_BREAKPOINTS.filter((deviceBreakpoint) => deviceBreakpoint !== breakpoint).reduce(
    (classValue, deviceBreakpoint) => hideAt(classValue, deviceBreakpoint),
    unhideAt(currentClass, ALL_DEVICES_BREAKPOINT)
  );

export const getHiddenClassTokens = (classValue) =>
  (classValue || '').split(' ').filter(isHiddenClassToken);

export const stripHiddenClassTokens = (currentClass) =>
  (currentClass || '')
    .split(' ')
    .filter((token) => token && !isHiddenClassToken(token))
    .join(' ');

export const applyHiddenClassTokens = (currentClass, tokens = []) => {
  if (!tokens.length) return currentClass || '';

  const strippedClass = stripHiddenClassTokens(currentClass);

  return strippedClass ? `${strippedClass} ${tokens.join(' ')}` : tokens.join(' ');
};
